import { useRiskOverviewResponse } from "./useRiskOverviewResponse";

function useRoleScoreList() {
  const { riskScore } = useRiskOverviewResponse();

  return {
    riskScore,
  };
}

export default useRoleScoreList;
